__turbopack_context__.v({
  "address_container": "styles-module-scss-module__2-3GOa__address_container",
  "address_wrapper": "styles-module-scss-module__2-3GOa__address_wrapper",
  "is_desktop": "styles-module-scss-module__2-3GOa__is_desktop",
  "is_mobile": "styles-module-scss-module__2-3GOa__is_mobile",
  "price_container": "styles-module-scss-module__2-3GOa__price_container",
  "property_header": "styles-module-scss-module__2-3GOa__property_header",
  "property_header_wrapper": "styles-module-scss-module__2-3GOa__property_header_wrapper",
  "stat": "styles-module-scss-module__2-3GOa__stat",
  "stat_container": "styles-module-scss-module__2-3GOa__stat_container",
  "stat_container_mobile": "styles-module-scss-module__2-3GOa__stat_container_mobile",
  "stat_wrapper": "styles-module-scss-module__2-3GOa__stat_wrapper",
});
